<template>
  <div class="bg">
      <div class="header">
          <div class="han">行业公告</div>
          <div class="eng">Industry Announcement</div>
      </div>
      <div class="body">
        <div class="sponser" v-for="(news,index) in newsList" :key="index">
            <div class="main-title">
                <div class="dash"></div>
                <div class="title">{{news.title}}</div>
            </div>
            <div class="date">{{news.date}}</div>
        </div>
      </div>
  </div>
</template>

<script>
// import moment from 'moment'
export default {
  components: {},
  data () {
    return {
      newsList: [
        {
          title: '2020中国跆拳道协会超级联赛竞赛日程',
          date: '2020-09-13'
        },
        {
          title: '中国跆拳道协会关于下发2020年中国泰拳带俱乐部超级联赛体能测试方案的通知',
          date: '2020-09-13'
        },
        {
          title: '中国跆拳道队东京奥运会参赛名单正式公布',
          date: '2020-09-13'
        },
        {
          title: '2021年国家跆拳道青少集训队和少儿集训队重庆选拔竞赛规程',
          date: '2020-09-13'
        }]
    }
  },
  created () {
    window.scrollTo(0, 0)
    // this.setDefaultMonth()
    // this.loadData()
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.bg {
//   width: 1200px;
width: 100%;
  margin: 90px auto;
  // padding-top: 100px;
  // background-color: #FFF;
//   background-color: red;
}
.header{
    width: 1200px;
    margin: 0 auto;
  height: 31px;
  color: #333;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  // margin-bottom: 47px;
}
.han{
  font-size: 30px;
  margin-right: 10px;
  font-weight: bold ;
}
.eng{
  font-size: 20px;
}
.body{
  width: 100%;
  margin-top: 40PX;
  padding-top: 30px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  background-color: #CECECE;
  // justify-content: space-around;
}
.sponser{
    width: 1200px;
    margin: 0 auto;
//   width: 100%;
//   height: 850px;
//   margin-right: 60px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #DDD;
}
.sponser-img{
  width: 100%;
  height: 100%;
}
.dash{
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #999;
    margin-right: 15px;
}
.main-title{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.title{
    font-size: 16px;
    font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/news/IndustryNotice.vue